/* eslint-disable no-useless-escape */
// 新手引导
import Treeselect from '@riophae/vue-treeselect'
import CONFIG from '@/config'
import { gtInit, gtDestroy } from '@/core/geetest/index'
import { GeeTestVersion } from '@/core/geetest/geetest'
import { operateLog } from '@/utils/tool'
import ERR_CONFIG from '@/config/responseError'
import PhonePrefix from '@/components/PhonePrefix'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import Tree from '@/components/Tree'
import DelPartLayer from '@/routes/main/admin/components/delPartLayer'
import {
  create_department,
  get_department_info,
  get_department_tree,
  get_members_list,
  remove_department,
  set_corp_info_old,
  set_department_info
} from '@/services/admin'
import { get_relationship, invite_member } from '@/services/colleague'
import { get_tag_list } from '@/services/edm'
import { create_tag, remove_tag, update_tag } from '@/services/tag'

export default {
  name: 'newcomer-guide',
  components: {
    'phone-prefix': PhonePrefix,
    'tree-select': Treeselect,
    Tree,
    DelPartLayer
  },
  provide() {
    return {
      provideData: {
        showAddSubDepart: this.showAddSubDepart, // 是否展示hover时的“添加子部门”按钮
        onlyShowIcon: this.onlyShowIcon // 是否只展示图标，不展示文字
      }
    }
  },
  data() {
    return {
      visible: false,
      nextBtnLoading: false,
      stepStatus: 'start',
      stepArr: ['start', 1, 2, 3, 4, 5, 'end'],
      steps: [
        this.$t('invite_colleague'),
        this.$t('add_depart'),
        this.$t('card_share_rules'),
        this.$t('create_company_tag'),
        this.$t('download')
      ],
      inviteBy: 'mobile', // 通过什么方式邀请 手机号/邮箱  'mobile'/'email'
      // 手机号
      mobileForm: [
        { area_code: '', mobile: '', errorTip: '' },
        { area_code: '', mobile: '', errorTip: '' },
        { area_code: '', mobile: '', errorTip: '' },
        { area_code: '', mobile: '', errorTip: '' },
        { area_code: '', mobile: '', errorTip: '' }
      ],
      // 邮箱
      emailForm: [
        { email: '', errorTip: '' },
        { email: '', errorTip: '' },
        { email: '', errorTip: '' },
        { email: '', errorTip: '' },
        { email: '', errorTip: '' }
      ],
      depart_tree: {},
      // 创建/编辑部门表单数据
      createDepartForm: {
        superiorDepartId: '', // 上级部门id
        departName: '', // 部门名称
        departMember: [], // 选中的部门成员
        canViewAllCard: false // 该部门员工有权查看该部门所有名片
      },
      createDepartRules: {
        departName: [{ required: true, message: this.$t('depart_name_not_empty'), trigger: 'blur' }]
      },
      departmentTree: [],
      panelType: 'add', // 创建/编辑  'add'/'edit'
      currentDepart: {}, // 当前点击的部门
      departMemberOptions: [], // 部门成员列表
      joinList: [], // 已加入公司员工列表
      unjoinList: [], // 未加入公司员工列表
      departMemberOrigin: [],
      showAddSubDepart: false,
      onlyShowIcon: true,
      delete_did: null,
      ruleRadio: 'shareByAuth',
      addTagLoading: false,
      newTagName: '',
      tagList: [],
      shareRulesStartTime: 0, // 统计停留时间
      downloadStartTime: 0,
      geetShow: false
    }
  },
  computed: {
    // “下一步”按钮是否禁用
    nextBtnDisabled() {
      return (
        this.stepStatus === 1 &&
        (this.inviteBy === 'mobile'
          ? this.mobileForm.every(e => !e.mobile.trim())
          : this.emailForm.every(e => !e.email.trim()))
      )
    },
    // 非标准用户
    notNormalRole() {
      return this.$store.state.user.user_info.role != CONFIG.USER_ROLE_NOMAL
    },
    // 安卓app下载地址
    android_app_url() {
      return this.$i18n.locale === 'zh-cn'
        ? 'https://s.intsig.net/software/CamCardBusiness.apk'
        : 'https://play.google.com/store/apps/details?id=com.intsig.camcard.enterprise'
    }
  },
  watch: {
    visible(v) {
      if (v) {
        this.guideOpen()
      }
    },
    inviteBy() {
      this.resetMobileEmailForm()
    },
    stepStatus(newV, oldV) {
      if (newV !== 1) {
        this.geetShow = false
      }
      if (newV === 3) {
        this.shareRulesStartTime = Date.now()
      } else if (newV === 5) {
        this.downloadStartTime = Date.now()
      }
      // 离开共享规则
      if (oldV === 3) {
        const diff = (Date.now() - this.shareRulesStartTime) / 1000
        this.$log.trace('CC_GUIDE_SHARE_RULE_STAY', {
          type: 'basic',
          value: diff
        })
      }
      // 离开下载app
      if (oldV === 5) {
        const diff = (Date.now() - this.downloadStartTime) / 1000
        this.$log.trace('CC_GUIDE_DOWNLOAD_STAY_TIME', {
          type: 'basic',
          value: diff
        })
      }
      // 进入部门
      if (newV === 2) {
        this.getDepartData()
      }
      // 离设置标签
      if (newV === 4) {
        this.getTagList()
      }
    }
  },
  mounted() {
    console.log(GeeTestVersion)
    // 如果是中文简体和韩语，默认通过手机号邀请，其他默认通过邮箱邀请
    this.inviteBy =
      this.$i18n.locale === 'zh-cn' || this.$i18n.locale === 'ko-kr' ? 'mobile' : 'email'

    this.$EventBus.$off('eventEditDepart').$on('eventEditDepart', (parentId, parentItem, item) => {
      this.panelType = 'edit'
      this.currentDepart = item
      this.createDepartForm.superiorDepartId = parentItem.id
      this.createDepartForm.departName = item.name
      this.getDepartMember(item.id)
      this.getDepartInfo(item.id)
    })
    this.$EventBus.$off('eventDelDepart').$on('eventDelDepart', id => {
      this.delete_did = id
      this.delDepart()
    })
  },
  methods: {
    startWrite() {
      this.stepStatus = 1
      this.$log.action('CC_GUIDE_START_FLOW', { type: 'count' })
    },
    // 新手引导打开时
    guideOpen() {
      this.getDepartData()
      this.getTagList()
    },
    getDepartData() {
      this.getDepartmentTree()
      this.getRelationship()
      this.getDepartMember(0)
    },
    // 邀请同事
    async handleInvite(result = {}) {
      try {
        let accounts = JSON.parse(
          JSON.stringify(this.inviteBy === 'mobile' ? this.mobileForm : this.emailForm)
        )
        accounts.forEach(f => {
          delete f.errorTip
        })
        if (this.inviteBy === 'mobile') {
          accounts = accounts.filter(f => f.mobile.trim())
        } else {
          accounts = accounts.filter(f => f.email.trim())
        }
        accounts = accounts.map(item => {
          const hostname = __DEV__ ? 'b12013.camcard.com' : window.location.hostname
          return {
            ...item,
            role: 0, // 参考php老逻辑
            superior: 0, // 参考php老逻辑
            privilege: 1, // 参考php老逻辑
            // dep_ids: [],
            language: this.$i18n.locale,
            callback: `https://${hostname}/user/join?corporation_id=${this.$store.state.user.user_info.corp_id}`
          }
        })
        const params = {
          accounts
        }
        if (result.geetest_challenge) {
          params.extra_params = {
            geetest_challenge: result.geetest_challenge,
            geetest_validate: result.geetest_validate,
            geetest_seccode: result.geetest_seccode,
            old_challenge: result.old_challenge,
            is_repeat_check: 0
          }
          gtDestroy()
          this.geetShow = false
        }
        this.nextBtnLoading = true
        const data = await invite_member({}, params)
        this.nextBtnLoading = false
        if (data?.err === 'need first check') {
          gtInit({}, data.data, true, this.$i18n.locale, this.handleInvite)
          this.geetShow = true
          console.log('*****显示极验弹窗')
          return
        }
        operateLog('邀请加入-new-guide', data)
        // this.error = '发送失败'
        this.inviteAccountError = []
        this.geetShow = false
        this.$nextTick(() => {
          data?.data?.accounts.forEach(item => {
            this.inviteAccountError.push(item)
          })
          // 判断是否全部邀请成功
          const okList = this.inviteAccountError.filter(item => item.error == 0)
          if (okList.length === accounts.length) {
            this.$message.success(this.$t('invite_send_ok'))
            this.skip(false) // 完成邀请后跳转下一步
            this.resetMobileEmailForm()
          } else {
            // 部分或全部邀请失败
          }
        })
      } catch (e) {
        this.geetShow = false
        this.nextBtnLoading = false
        this.$message.error(this.$t('err_networkbusy'))
        operateLog('邀请加入error-new-guide', e)
      }
    },
    resetMobileEmailForm() {
      this.mobileForm.forEach(f => {
        f.area_code = ''
        f.mobile = ''
        f.errorTip = ''
      })
      this.emailForm.forEach(f => {
        f.email = ''
        f.errorTip = ''
      })
    },
    async getDepartmentTree() {
      try {
        const data = await get_department_tree({
          dep_id: 0
        })
        if (data.errno === 0) {
          const _data = JSON.parse(JSON.stringify(data.data))
          this.handleTreeData(_data, 1)
          this.depart_tree = _data
        } else {
          this.$message.error(this.$t('err_networkbusy'))
        }
      } catch (e) {
        this.$message.error(this.$t(this.$formatErrorTxt(e, 'CORPAPI')))
      }
    },
    handleTreeData(treeData, level = 1) {
      if (!Array.isArray(treeData)) return
      treeData.forEach(f => {
        f.level = level
        if (Array.isArray(f.subs) && f.subs.length) {
          this.handleTreeData(f.subs, level + 1)
        }
      })
    },
    // 获取部门树-下拉选择框
    async getRelationship() {
      try {
        const data = await get_relationship({
          type: 'all_department_tree'
        })
        if (data) {
          this.departmentTree = data.data
          if (this.departmentTree && this.departmentTree.length > 0) {
            this.createDepartForm.superiorDepartId = this.departmentTree[0].id
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 获取某部门下的成员
    // dep_id: 0 代表全公司
    async getDepartMember(dep_id) {
      try {
        const data = await get_members_list({
          did: dep_id,
          start_num: 0,
          num: 300000,
          keyword: '',
          member_type: 'department_account'
        })
        if (data.errno == 0) {
          const allList = data.data.all.list.flat(1)
          this.joinList = allList.map(m => m.user_id)
          let unjoinList = []
          if (data.data.unjoin && Array.isArray(data.data.unjoin.list)) {
            unjoinList = data.data.unjoin.list.flat(1)
          }
          this.unjoinList = unjoinList.map(m => m.account)
          this.departMemberOptions = allList.concat(unjoinList)
          if (this.panelType === 'edit') {
            const dep = data.data.dep.list.map(item => item.user_id)
            const unjoin_dep = data.data.unjoin_dep.list.map(item => item.account)
            this.createDepartForm.departMember = dep.concat(unjoin_dep)
            // 保留一份原始数据，用来update时，del 参数赋值
            this.departMemberOrigin = dep.concat(unjoin_dep)
          }
        } else {
          this.$message.error(this.$t('err_networkbusy'))
        }
      } catch (e) {
        this.$message.error(this.$t(this.$formatErrorTxt(e, 'CORPAPI')))
      }
    },
    async getDepartInfo(dep_id) {
      try {
        const data = await get_department_info({
          dep_id
        })
        if (data.errno == 0) {
          this.createDepartForm.canViewAllCard = !!data.data.flag_share
        } else {
          this.$message.error(this.$t('err_networkbusy'))
        }
      } catch (e) {
        this.$message.error(this.$t(this.$formatErrorTxt(e, 'CORPAPI')))
      }
    },
    delDepart() {
      this.$refs.delDepartLayer.changeLayerVisible()
    },
    deleteDepart() {
      // 删除部门
      if (!this.delete_did) return
      this.delDepartInfo(this.delete_did)
    },
    async delDepartInfo(dep_id) {
      try {
        const data = await remove_department({
          dep_id
        })
        if (data.errno === 0) {
          this.$message.success(this.$t('edm_delete_success'))
          this.getDepartmentTree()
          this.getRelationship()
        } else {
          this.$message.error(this.$t('modify_fail'))
        }
      } catch (e) {
        this.$message.error(this.$t(this.$formatErrorTxt(e, 'CORPAPI')))
      }
    },
    // 确认创建/保存 部门
    createEditDepart() {
      this.$refs.createEditDep.validate(isValid => {
        if (!isValid) return
        let deleteList = []
        if (this.panelType === 'edit' && this.departMemberOrigin.length) {
          deleteList = this.departMemberOrigin.filter(
            user_id => !this.createDepartForm.departMember.includes(user_id)
          )
        }
        const basic_param = {
          name: this.createDepartForm.departName,
          notation: this.createDepartForm.departName,
          superior_did: this.createDepartForm.superiorDepartId,
          flag_share: this.createDepartForm.canViewAllCard ? 1 : 0
        }
        this.panelType === 'edit'
          ? this.setDepartmentInfo(
              this.currentDepart.id,
              Object.assign(basic_param, {
                add: this.createDepartForm.departMember.filter(f => this.joinList.includes(f)),
                add_unjoined: this.createDepartForm.departMember.filter(f =>
                  this.unjoinList.includes(f)
                ),
                del: deleteList
              })
            )
          : this.createDepartment(
              Object.assign(basic_param, {
                members: this.createDepartForm.departMember.filter(f => this.joinList.includes(f)),
                unjoined_memebers: this.createDepartForm.departMember.filter(f =>
                  this.unjoinList.includes(f)
                )
              })
            )
      })
    },
    async setDepartmentInfo(dep_id, params) {
      try {
        await set_department_info(
          {
            dep_id
          },
          {
            ...params
          }
        )
        this.resetData()
        this.getDepartmentTree()
        this.getRelationship()
        this.$message.success(this.$t('modify_ok'))
      } catch (e) {
        this.$message.error(this.$t(this.$formatErrorTxt(e, 'CORPAPI')))
      }
    },
    async createDepartment(params) {
      try {
        const data = await create_department(
          {},
          {
            ...params
          }
        )
        if (data.errno === 0) {
          this.resetData()
          this.getDepartmentTree()
          this.getRelationship()
          this.$message.success(this.$t('edm_filter_add_success'))
        } else {
          this.$message.error(this.$t('modify_fail'))
        }
      } catch (e) {
        this.$message.error(this.$t(this.$formatErrorTxt(e, 'CORPAPI')))
      }
    },
    resetData() {
      this.panelType = 'add'
      this.createDepartForm.departName = ''
      this.createDepartForm.departMember = []
      this.createDepartForm.canViewAllCard = false
    },
    // 设置名片共享规则
    async setCorpInfoOld() {
      const reqBody = {
        privilege: this.ruleRadio === 'shareByAuth' ? 1 : 0
        // privilege_admin_tag: 1 // 参考php老逻辑，固定传1
      }
      try {
        this.nextBtnLoading = true
        await set_corp_info_old({}, reqBody)
        this.nextBtnLoading = false
        this.skip(false)
      } catch (e) {
        this.nextBtnLoading = false
        this.$message.error(this.$t(this.$formatErrorTxt(e, 'CORPAPI')))
      }
    },
    async getTagList() {
      const data = await get_tag_list({
        start_num: 0,
        num: 30000,
        sort_id: 1
      })
      this.tagList = data.data.list || []
    },
    handleHover(item) {
      this.$set(item, 'hover', true)
    },
    handleOver(item) {
      this.$set(item, 'hover', false)
    },
    editTagInput(event) {
      event.stopPropagation()
    },
    async cfmEdit(item) {
      const formData = {}
      item.editName = item.editName.trim()
      if (!item.editName) {
        this.$message.error(this.$t('input_tag_name'))
        return
      }
      if (item.editName.length > 80) {
        this.$message.error(this.$t('moren_than_largest_length'))
        return
      }
      formData[item.tag_id] = item.editName
      try {
        await update_tag({}, formData)
        this.$set(item, 'tag_name', item.editName)
        this.cancleEdit(item)
      } catch (e) {
        // this.cancleEdit(item)
        this.$message.error(this.$t(this.$formatErrorTxt(e, 'SyncAPI')))
      }
    },
    cancleEdit(item) {
      this.$set(item, 'edit', false)
      this.$set(item, 'editName', item.tag_name)
    },
    editTag(event, item) {
      event.stopPropagation()
      this.$set(item, 'edit', true)
      this.$set(item, 'editName', item.tag_name)
    },
    deleteTag(item) {
      this.$confirm(this.$t('dialog_confirm_delete_tag'), this.$t('delete_tag'), {
        cancelButtonText: this.$t('cancel'),
        confirmButtonText: this.$t('confirm_delete'),
        confirmButtonClass: 'btn-danger-style',
        closeOnClickModal: false,
        beforeClose: (action, instance, done) => {
          if (action == 'confirm') {
            instance.confirmButtonLoading = true
            remove_tag({}, [item.tag_id])
              .then(() => {
                instance.confirmButtonLoading = false
                done()
                this.getTagList()
              })
              .catch(e => {
                instance.confirmButtonLoading = false
                done()
                this.$message.error(this.$t(this.$formatErrorTxt(e, 'SyncAPI')))
              })
          } else {
            done()
          }
        }
      }).catch(() => {})
    },
    async handleCreateTag() {
      const new_tag = this.newTagName.trim()
      if (new_tag.length > 80) {
        this.$message.error(this.$t('moren_than_largest_length'))
        return
      }
      try {
        this.addTagLoading = true
        await create_tag({}, [new_tag])
        this.getTagList()
        this.addTagLoading = false
        this.$message.success(this.$t('add_tag_ok', [new_tag]))
        this.newTagName = ''
      } catch (e) {
        if (e.errno == ERR_CONFIG.NO_PERMISSION_OPERATION) {
          // 无权限
          this.$message.error(this.$t('err_nopermit'))
        } else if (e.errno == 621) {
          this.$message.error(this.$t('tagname_exist'))
        }
        this.addTagLoading = false
        this.$message.error(this.$t(this.$formatErrorTxt(e, 'SyncAPI')))
      }
    },
    // 跳过
    skip(needLog = true) {
      // needLog: 是否需要上报日志
      const logConfig = [
        '',
        'CC_GUIDE_INVITE_SKIP',
        'CC_GUIDE_ADD_DEPARTMENT',
        'CC_GUIDE_SHARE_RULE_SKIP',
        'CC_GUIDE_LABEL_MANAGER_SKIP',
        ''
      ]
      needLog &&
        logConfig[this.stepStatus] &&
        this.$log.action(logConfig[this.stepStatus], { type: 'count' })
      this.stepStatus = this.stepStatus + 1 >= 6 ? 'end' : this.stepStatus + 1
    },
    // 上一步
    prevStep() {
      const logConfig = [
        '',
        '',
        'CC_GUIDE_ADD_DEPARTMENT_BEFORE',
        'CC_GUIDE_SHARE_RULE_BEFORE',
        'CC_GUIDE_LABEL_MANAGER_BEFORE',
        'CC_GUIDE_DOWNLOAD_BEFORE'
      ]
      logConfig[this.stepStatus] && this.$log.action(logConfig[this.stepStatus], { type: 'count' })
      this.stepStatus = this.stepStatus - 1
    },
    // 下一步/保存并继续
    nextStep() {
      const logConfig = [
        '',
        'CC_GUIDE_INVITE_ADMIN',
        'CC_GUIDE_ADD_DEPARTMENT_AFTER',
        'CC_GUIDE_SHARE_RULE_AFTER',
        'CC_GUIDE_LABEL_MANAGER_AFTER',
        'CC_GUIDE_DOWNLOAD_COMPLETE'
      ]
      logConfig[this.stepStatus] && this.$log.action(logConfig[this.stepStatus], { type: 'count' })
      // 邀请同事
      if (this.stepStatus === 1) {
        this.$nextTick(() => {
          if (this.mobileForm.some(s => s.errorTip) || this.emailForm.some(s => s.errorTip)) {
            const err =
              this.inviteBy === 'mobile'
                ? this.mobileForm[this.mobileForm.findIndex(f => f.errorTip)].errorTip
                : this.emailForm[this.emailForm.findIndex(f => f.errorTip)].errorTip
            this.$message.error(err)
            return
          }
          this.handleInvite()
        })
      } else if (this.stepStatus === 3) {
        // 名片共享规则
        this.setCorpInfoOld()
      } else {
        this.skip(false)
      }
    },
    closeGuide() {
      this.visible = false
      location.reload() // 刷新页面，获取最新组织及标签信息
    },
    guideClosed() {
      this.stepStatus = 'start'
      this.resetData()
    },
    normalizer(node) {
      return {
        id: node.id,
        label: node.name,
        children: node.subs
      }
    },
    isMobile(val) {
      const rmobile = /^[+]{0,1}\d+$/
      if (!val) return 2
      return rmobile.test(val) ? 0 : 1
    },
    isEmail(val) {
      const remail =
        /^[A-Za-z0-9!#$%&\'*+\/=?^_`{|}~-]+(\.[A-Za-z0-9!#$%&\'*+\/=?^_`{|}~-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.([A-Za-z]{2,})$/
      if (!val) return 2
      // return remail.test(val) ? /@\./.test(val) ? 1 : 0 : 1;
      return remail.test(val) ? 0 : 1
    },
    isNumber(val) {
      if (val === 0) return 0
      if (!val) return 2
      return `${parseInt(val, 10)}` === `${val}` ? 0 : 1
    },
    validateMobile(index) {
      const { area_code } = this.mobileForm[index]
      const mobile = this.mobileForm[index].mobile.trim()
      if (!mobile) return
      if (this.isMobile(mobile) !== 0 || (area_code == '86' && mobile.length != 11)) {
        this.mobileForm[index].errorTip = this.$t('err_invalidphone')
      } else if (this.isNumber(area_code) != 0) {
        this.mobileForm[index].errorTip = this.$t('err_invalidphone')
      }
    },
    validateEmail(index) {
      const email = this.emailForm[index].email.trim()
      if (!email) return
      if (this.isEmail(email) !== 0) {
        this.emailForm[index].errorTip = this.$t('err_invalidemail')
      }
    }
  }
}
